import axios from 'axios';
import { smartAuditBaseURL } from '@app/api/http.api';

/**
 * Smart Audit client without the shared interceptors of `http.api` (D9): checks made through it stay silent, so a
 * network error or a 5xx shows no toast and a 401 does not sign the user out of the whole app.
 */
export const httpApiSmartAuditSilent = axios.create({ baseURL: smartAuditBaseURL });
